import React, { useRef } from "react";
import styled from "@emotion/styled";
import MenuItemDisplay3 from "./MenuItemDisplay3";
import { ThemeContext, UserContext } from "../contexts/Context";

const CheckoutRecommendationItems = ({ recommendation, cart, onSelectItem }) => {
  const themeContext = React.useContext(ThemeContext);
  const { lanIndex, currencySymbol, isLanReverse } = React.useContext(UserContext);
  const menuSelectionFormRef = useRef(null);

  const selectedItems = cart.reduce((items, item) => {
    items[item.codeId] = (items[item.codeId] || 0) + item.qty;
    return items;
  }, {});

  const selectRecommendedItem = (item) => {
    item.recommendId = "MREC";
    onSelectItem(item);
  };

  if (!recommendation || !Array.isArray(recommendation.options) || recommendation.options.length === 0) {
    return null;
  }

  return (
    <RecommendationSection themeContext={themeContext}>
      <RecommendationHeading themeContext={themeContext}>
        Recommended for you
      </RecommendationHeading>
      <RecommendationList>
        {recommendation.options.map((item, index) => (
          <MenuItemDisplay3
            key={item.codeId || index}
            item={item}
            lanIndex={lanIndex}
            isLanReverse={isLanReverse}
            currencySymbol={currencySymbol}
            selectedItems={selectedItems}
            setSelectedMenu={selectRecommendedItem}
            menuSelectionFormRef={menuSelectionFormRef}
          />
        ))}
      </RecommendationList>
    </RecommendationSection>
  );
};

export default React.memo(CheckoutRecommendationItems);

const RecommendationSection = styled.section`
  width: calc(100% - 24px);
  max-width: 550px;
  margin: 4px 12px 12px;
  padding: 8px 0;
  overflow: hidden;
  background-color: ${(props) => props.themeContext.optionBorderColor};
  
`;

const RecommendationHeading = styled.div`
  padding: 0 10px 4px;
  color: ${(props) => props.themeContext.primaryColor};
  font-family: ${(props) => props.themeContext.fontFamily};
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-align: left;
  text-transform: uppercase;
`;

const RecommendationList = styled.div`
  display: flex;
  gap: 4px;
  width: 100%;
  padding: 4px 6px;
  box-sizing: border-box;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
  scroll-snap-type: x proximity;
  -webkit-overflow-scrolling: touch;


  &::-webkit-scrollbar {
    display: none;
  }
`;
